import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import moment from 'moment-timezone';
import React, { useRef, useState } from 'react';

import { TargetTypeLabel } from '../../../components/Curation/Labels';
import { IAbTestVariant, ICollection, IFeaturedCard, ISegmentCurationCollection, ISegmentCurationFeaturedCard } from '../../../services/types';
import { getStatusByDates } from '../../../services/utils';
import useStyles, { statusColors } from './styles';
import { ISegmentCurationAbTest } from '../../../services/types/index';

interface InfoProps {
  abtestItem: ISegmentCurationAbTest;
}

export const AbtestInfoBox = (props: InfoProps): JSX.Element => {
  const classes = useStyles();
  const { abtestItem } = props;
  const startsAt = abtestItem.startsAt || null;
  const endsAt = abtestItem.endsAt || null;
  const status = getStatusByDates(startsAt, endsAt);

  const renderItem = (variant: IAbTestVariant, idx: number) => {
    if (variant.data!.type === 'featured_card') {
      return variant.object ? (
        <Box className={classes.abtestInfoVariant} display="flex" alignItems="center" key={`abtest-variant-render-item-featured-${variant.id!}`}>
          <Box marginRight={'15px'}>
            <div
              style={{
                backgroundImage: `url(${process.env.CDN_URL}/${(variant!.object as IFeaturedCard)!.displayCoverUrl ||
                  variant!.object!.coverUrl}?w=320)`,
              }}
              className={classes.coverImage}
            />
          </Box>
          <Box>
            <div className={classes.abtestInfoVariantTitle}>
              Variant {String.fromCharCode(65 + idx)} (Variant ID : {variant.id || '-'})
            </div>
            <div>
              <TargetTypeLabel type={variant.object!.type} /> {variant.object!.title}
            </div>
          </Box>
        </Box>
      ) : (
        <Alert severity="warning">Variant has no object data.</Alert>
      );
    } else {
      return variant.object ? (
        <Box
          className={classes.abtestInfoVariant}
          key={`abtest-variant-render-item-collection-43
        ${variant.id!}`}
        >
          <Box display="flex">
            <div className={classes.abtestInfoVariantTitle}>
              Variant {String.fromCharCode(65 + idx)} (Variant ID : {variant.id || '-'})
            </div>
            <div className={classes.abtestInfoVariantTrackingId}>Tracking ID : {(variant!.object as ICollection)!.trackingId}</div>
            <div>Stories: {(variant!.object as ICollection)!.storyCount}</div>
          </Box>
          <Box>
            <div>{variant.object!.title}</div>
          </Box>
        </Box>
      ) : (
        <Alert severity="warning">Variant has no object data.</Alert>
      );
    }
  };
  return (
    <Box className={classes.abtestInfoBox}>
      <Box className={classes.abtestInfoSection}>
        A/B Test Status :{' '}
        <span style={{ color: statusColors[status], textTransform: 'capitalize' }}>{getStatusByDates(abtestItem.startsAt!, abtestItem.endsAt!)}</span>
      </Box>
      <Box className={classes.abtestInfoDate}>
        Test period : {moment(startsAt).format('lll')} ~ {endsAt !== null ? moment(endsAt).format('lll') : ''}
      </Box>
      {abtestItem.variants!.map((variant, idx) => renderItem(variant, idx))}
    </Box>
  );
};
